<header id="header" [ngClass]="{'topstrip': addForTopStrip}" class="header-bg">
  <div class="demoblock" [class.hide]="isHiding"><span>FOR DEMO PURPOSE ONLY <a href="javascript:(0)" (click)="dismiss($event)">Dismiss</a></span></div>
  <nav class="navbar navbar-expand-md fixed-top ">
    <div class="container">
      <div>
        <div class="hide-search mbl-show mr-3">
          <button id="navbar-toggle-button" class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarsExample04"
            aria-controls="navbarsExample04" aria-expanded="false" aria-label="Toggle navigation">
              <img class="menubar" src="../../../../assets/img/Icon/menu-bar.svg" />
              <img class="menuclose" src="../../../../assets/img/Icon/close.svg" />
          </button>
        </div>
        <a (click)="gotToTab()" class="navbar-brand"><img
        src="assets/img/logo.png" /></a>
      </div>

      
            
            <ul class="mbl-nav">
              <li (click)="openLanguage(switchLanguageModal)">
                 <img src="../../../../assets/img/Icon/language.svg" />
              </li>
              <li (click)="openSearchModal($event)">
                <img src="../../../../assets/img/Icon/search-mbl.svg" />
              </li>
            </ul>

          <span class="login-btn-mbl" *ngIf="isAuthenticated==false" id="login-button" (click)="openLoginModal(loginContent)" #icl>
              <img src="/assets/img/Icon/login-register.svg" />
          </span >

          <span *ngIf="isAuthenticated" class="nav-link dropdown-toggle login-btn-mbl" id="dropdown04" data-toggle="dropdown" aria-haspopup="true">
                    <img
                      *ngIf="!selectedProfile?.profile_image" src="/assets/img/Icon/default-user.svg" class="mr-2 p-placeholder-img" /> 
                    <image-manipulation *ngIf="selectedProfile?.profile_image"
                      class="mr-2 p-select-img"
                      [img]="selectedProfile?.profile_image"
                      [params]="{ 'crop': 'scale', 'width': 220, 'height': 220 }"
                      notFound="square"></image-manipulation>
              </span>
              
                <!-- <a *ngIf="isAuthenticated" class="nav-link dropdown-toggle" id="dropdown04" data-toggle="dropdown" aria-haspopup="true"> 
                
                  <img
                    *ngIf="!selectedProfile?.profile_image" src="/assets/img/Icon/default-user.svg" class="mr-2 p-placeholder-img" /> 
                  <image-manipulation *ngIf="selectedProfile?.profile_image"
                    class="mr-2 p-select-img"
                    [img]="selectedProfile?.profile_image"
                    [params]="{ 'crop': 'scale', 'width': 220, 'height': 220 }"
                    notFound="square"></image-manipulation>
                  <img src="/assets/img/Icon/arrow_down.svg" />
                </a> -->
                

            
        <div class="collapse navbar-collapse" id="navbarsExample04">
          <ul #tabContainer class="navbar-nav menu-width">
            <li class="nav-item" *ngFor="let item of visibleTabs; let i=index"
              [ngClass]="{'active': slugName == item.slug}">
              <a class="nav-link" (click)="highLightMenu(item.slug,item.name,item)" routerLinkActive="active">{{item.name}}
              </a>
            </li>

            <li *ngIf="hiddenTabs?.length > 0" class="nav-item" style="position: relative">
            <a class="nav-link" href="javascript:;">
              <span class="menu-hover-icon"></span>
            </a>
            <ul class="sub-menu">
              <li class="nav-item" *ngFor="let item of hiddenTabs; let i=index"
                [ngClass]="{'active': slugName == item.slug}">
                <a class="nav-link" (click)="highLightMenu(item.slug,item.name,item)" routerLinkActive="active">{{item.name}}
                </a>
              </li>
            </ul>
          </li>
          
          
          <!-- <ul class="navbar-nav mbl-menu">
            <li class="nav-item" *ngFor="let item of headerTabs let i=index"
              [ngClass]="{'active': slugName == item.slug}">
              <a class="nav-link" (click)="highLightMenu(item.slug,item.name)" routerLinkActive="active">{{item.name}}
              </a>
            </li>
          </ul>
          <ul class="navbar-nav desktop-menu">
            <li class="nav-item" *ngFor="let item of headerTabs | slice:0:6; let i=index"
              [ngClass]="{'active': slugName == item.slug}">
              <a class="nav-link" (click)="highLightMenu(item.slug,item.name)" routerLinkActive="active">{{item.name}}
              </a>
            </li>
  
            <li *ngIf="headerTabs.length>6" class="nav-item" style="position: relative;">
              <a class="nav-link" href="javascript:;">
                <span class="menu-hover-icon"></span>
              </a>
              <ul class="sub-menu">
                <li class="nav-item" *ngFor="let item of headerTabs | slice:6; let i=index"
                  [ngClass]="{'active': slugName == item?.slug}">
                  <a class="nav-link" (click)="highLightMenu(item?.slug,item.name)" routerLinkActive="active">{{item?.name}}
                  </a>
                </li>
              </ul>
            </li>
          </ul> -->
          </ul>
        </div>
        <form class="form-inline">
          <ul class="form_right mobile-display-block">
            <li class="language-nav">
              <a class="dropdown-item" (click)="openLanguage(switchLanguageModal)">
                <span>{{ 'language' | translate }} <img src="../../../../assets/img/Icon/arrow_down.svg" /></span></a>
                <!-- <ng-template #switchLanguageModal> -->
                <div #dropdownRef *ngIf="isOpen" class="modal-content-bg">
                  
                  <ul class="manage-radio language-scroll">
                        <li *ngFor="let language of availableLanguages"
                        [ngClass]="{'manage-active-radio': selectedLanguage.toLowerCase() === language.code.toLowerCase()}"
                        (click)="changeLanguage(language.code)"> {{ setLanguageTitle(language) }}</li>
                        
                  </ul>
                </div>
                <!-- </ng-template> -->
            </li>
            <li class="search-icon"><a (click)="openSearchModal($event)">
              <span></span>
            </a></li>
            
            <li class="subscribe-img" *ngIf="showSubscribeButton">
              <a (click)="goToSubscribe(loginContent)" #icl>
                <span class="head_btn btn_hover">
                  <img src="/assets/img/Icon/subscribe.svg" />
                  <p>{{'subscribe.title' | translate}}</p>
                </span>
              </a>
            </li>
  
            <li class="nav-item dropdown ">
              <a class="desktop-show" id="login-button" (click)="openLoginModal(loginContent)" #icl>
                  <span class="head_btn btn_hover" *ngIf="isAuthenticated==false">
                    <img src="/assets/img/Icon/login.svg" />
                    <p>{{'login' | translate}}</p>
                  </span>
              </a>
              <a class="nav-link dropdown-toggle desktop-show" id="dropdown04" data-toggle="dropdown" aria-haspopup="true"> 
                  <div *ngIf="isAuthenticated">
                    <img
                      *ngIf="!selectedProfile?.profile_image" src="/assets/img/Icon/default-user.svg" class="mr-2 p-placeholder-img" /> 
                    <image-manipulation *ngIf="selectedProfile?.profile_image"
                      class="mr-2 p-select-img"
                      [img]="selectedProfile?.profile_image"
                      [params]="{ 'crop': 'scale', 'width': 220, 'height': 220 }"
                      notFound="square"></image-manipulation>
                    <img src="/assets/img/Icon/arrow_down.svg" />
                  </div>
              </a>
              <div class="dropdown-menu right-align-menu" aria-labelledby="dropdown04">
                <div *ngIf="isAuthenticated == true">
                  <div class="header-profile-list">
                    <ul>
                      <li *ngFor="let item of profileData" [ngClass]="{'profile_active no_click': item._id == selectedProfile._id}">
                        <a (click)="switchProfile(item._id, item.profile_name, item.profile_lock, item.profile_image)">
                          <div class="profile-list-border">
                            <!-- <img [src]="item?.profile_image || defaultImageUrl" alt="" title="" /> -->
                            <image-manipulation
                              class="mr-2 p-select-img"
                              [img]="item?.profile_image"
                              [params]="{ 'crop': 'scale', 'width': 220, 'height': 220 }"
                              notFound="square"></image-manipulation>
                            <span *ngIf="item.is_child">{{'kids' | translate}}</span>
                          </div>
                          <span class="header-profile-name">
                            <img *ngIf="item.profile_lock" src="/assets/img/Icon/lock.svg" alt="" title="" />
                            {{item.profile_name}}
                          </span>
                        </a>
                      </li>
                      <li *ngIf="addProfileCount" routerLink="manage-profile/add">
                        <a>
                          <div class="profile-list-border add_p_account">
                            <img src="/assets/img/Icon/add_profile.svg" alt="" title="" />
                          </div>
                          <span class="header-profile-name">
                            {{'addProfile' | translate}}
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <span class="menu-line"></span>
                  <a class="dropdown-item" routerLink="/manage-profile" [queryParams]="{ is_manage: true }" routerLinkActive="active" aria-disabled="true"><img src="/assets/img/Icon/manage_profile.svg" alt="" title="" /> {{'manageProfile' | translate}}</a>

                  <a *ngIf="showSubscribeButton" class="dropdown-item mbl-show" (click)="goToSubscribe(loginContent)" #icl aria-disabled="true">
                    <img src="/assets/img/Icon/subscribe.svg" alt="" title="" />
                    <img src="/assets/img/Icon/subscribe.svg" alt="" title="" />
                    
                    {{'subscribe.title' | translate}}</a>

                  <a class="dropdown-item" routerLink="/myaccount" routerLinkActive="active" aria-disabled="true">
                    <img src="/assets/img/Icon/my_account.svg" alt="" title="" />
                    <img src="/assets/img/Icon/my_account-active.svg" alt="" title="" />
                    
                    {{'myaccount' | translate}}</a> 
                  <a class="dropdown-item" routerLink="/myplans" routerLinkActive="active" aria-disabled="true">
                    <img src="/assets/img/Icon/my_subscriptions.svg" alt="" title="" />
                    <img src="/assets/img/Icon/my_subscriptions-active.svg" alt="" title="" />
                    
                    {{'myPlans' | translate}}</a>
                  <a class="dropdown-item" routerLink="/watchlist" routerLinkActive="active" aria-disabled="true">
                    <img src="/assets/img/Icon/my_watchlist.svg" alt="" title="" />
                    <img src="/assets/img/Icon/my_watchlist-active.svg" alt="" title="" />
                    {{'watchlist.title' | translate}}</a>
                  <a class="dropdown-item" routerLink="/redeem-code" routerLinkActive="active" aria-disabled="true">
                    <img src="/assets/img/Icon/redeem_code.svg" alt="" title="" />
                    <img src="/assets/img/Icon/redeem_code-active.svg" alt="" title="" />
                    {{'redeedmCode' | translate}}</a>
                  <a class="dropdown-item" routerLink="/help-center" routerLinkActive="active">
                    <img src="/assets/img/Icon/help_center.svg" alt="" title="" />
                    <img src="/assets/img/Icon/help_center-active.svg" alt="" title="" />
                    
                    {{'helpCenter' | translate}}</a>
                  <!-- <a class="dropdown-item" (click)="openTellUs(switchLanguageModal)">
                    <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-language"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 5h7" /><path d="M9 3v2c0 4.418 -2.239 8 -5 8" /><path d="M5 9c0 2.144 2.952 3.908 6.7 4" /><path d="M12 20l4 -9l4 9" /><path d="M19.1 18h-6.2" /></svg>
                    {{ 'switchLanguage' | translate }}</a> -->
                  <span class="menu-line"></span>
                  <a id="header-logout-button" class="dropdown-item" (click)="openConfirmLogoutModal(confirmLogoutModal)"><img src="/assets/img/Icon/logout.svg" alt="" title="" /> {{'logOut' | translate}}</a>
                </div>
              </div>
  
  
            </li>
  
            
          </ul>
        </form>
        
      
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample04"
        aria-controls="navbarsExample04" aria-expanded="false" aria-label="Toggle navigation"
        style="display:none !important;">
        <span class="navbar-toggler-icon">
          <i class="fa fa-bars" aria-hidden="true"></i>
        </span>
      </button>
      
      
      
    </div>

  </nav>
</header>



<ng-template #confirmLogoutModal>
  <div class="popup_background auth">
      <div class="modal-content" *ngIf="!logoutSuccess">
        <p class="text-white">{{'areYouSureYouWantToLogout' | translate}}</p>

        <div class="text-right mt-5">
            <button class="btn btn-default btn_hover profile-btn mr-3 btn_height30" (click)="closeModal()">
                <span>{{'cancel' | translate}}</span>
            </button>
            <button class="btn btn-default btn_hover profile-btn btn_height30" (click)="logout()">
              <span>{{'yesLogout' | translate}}</span>
            </button>
        </div>
      </div>
      <div *ngIf="logoutSuccess" class="modal-content">
        <div class="success-add">
            <h2 style="color:#fff;font-size: 20px;font-weight: 100;line-height: 35px;"
            class="_verify_t">
            {{api_msg}}
            </h2>
            <div class="lottie-icon-block">
              <div class="lottie-icon">
                  <ng-lottie [options]="successOptions"></ng-lottie>
              </div>
          </div>
        </div>
    </div>
  </div>
</ng-template>

<ng-template #loginContent let-modal>
  <app-login-register></app-login-register>
</ng-template>

<ng-template #searchComponent>
  <app-search></app-search>
</ng-template>

<!-- <ng-template #tellUsContent let-modal>
  <app-tell-us></app-tell-us>
</ng-template> -->